import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths, ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';

import MutationKeys from './keys';

type UnarchiveContentInput = {
    id: number;
    type: string;
};

const useUnarchiveContent = (mutateOptions?: UseMutationOptions<unknown, Error, UnarchiveContentInput>) =>
    useMutation<UnarchiveContentInput>(
        MutationKeys.UNARCHIVE_CONTENT,
        CuredApiPaths.CONTENT_UNARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useUnarchiveContent;
